<template>
  <div
    v-show="$store.state.displayLayerMenu"
    class="layer-container"
  >
    <mq-layout :mq="['mobile', 'tablet']">
      <view-box
        :heading="$t('layerView.heading')"
        icon="mdi-layers"
        style="overflow-y: auto;"
      >
        <v-card class="mobileLayerCard">
          <div class="base-map">
            <h3 class="unselectable">
              {{ $t('layerView.baseMap') }}
            </h3>
            <v-select
              v-model="defaultLayer"
              class="comboBox"
              :items="layerItems"
              label="Hintergrundkartekarte auswählen"
              mandatory
              full-width
              no-data-text="Bitte Hintergrundkartenkarten hinterlegen"
            >
              <template
                slot="selection"
                slot-scope="data"
                class="base-container"
              >
                <v-card
                  style="border-radius: 10px;"
                  elevation="4"
                >
                  <v-img
                    :src="data.item.meta.image"
                    class="preview-image layer-image"
                    height="60px"
                    cover
                    gradient="to bottom, rgba(115,115,115,.33), rgba(70,70,70,.5)"
                  >
                    <p class="text-center item-text text-white unselectable">
                      {{ data.item.meta.name }}
                    </p>
                  </v-img>
                </v-card>
              </template>
              <template
                slot="item"
                slot-scope="data"
                class="base-container"
              >
                <v-img
                  :src="data.item.meta.image"
                  class="option-image layer-image"
                  height="60px"
                  cover
                  gradient="to bottom, rgba(115,115,115,.33), rgba(70,70,70,.5)"
                  @click="setLayerVisible(data.item.meta.lid)"
                >
                  <p class="text-center item-text text-white unselectable">
                    {{ data.item.meta.name }}
                  </p>
                </v-img>
              </template>
            </v-select>
          </div>
          <div
            class="overlays"
          >
            <h3 class="unselectable">
              {{ $t('layerView.vectorLayer') }}
            </h3>
            <div id="overlay-option">
              <v-text-field
                v-if="items.length > 10"
                v-model="search"
                class="search-bar"
                :label="$t('layerView.searchVectorLayer')"
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
              />
              <v-treeview
                v-model="selection"
                selectable
                :selected-color="baseColorAccent"
                open-on-click
                transition
                hoverable
                :items="items"
                :search="search"
                @input="onOverlayUpdate"
              >
                <template v-slot:append="{item}">
                  <v-icon
                    v-if="item.selectable"
                  >
                    mdi-cursor-pointer
                  </v-icon>
                </template>
              </v-treeview>
            </div>
          </div>
        </v-card>
      </view-box>
    </mq-layout>
    <mq-layout mq="desktop">
      <v-card
        class="desktopLayerCard"
      >
        <div
          class="base-map"
          style="width: 50%;overflow-y:auto;"
        >
          <h3
            class="unselectable"
          >
            {{ $t('layerView.baseMap') }}
          </h3>
          <v-container fluid>
            <v-row>
              <v-col
                v-for="(layer,n) in layerItems"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card
                  :id="layer.meta.lid"
                  :ref="layer.meta.lid"
                  tile
                  class="d-flex base-layer-card"
                  hover
                  @click="setLayerVisible(layer.meta.lid);"
                >
                  <!-- src="https://gisdemo2.mum.de/TileServer/TileServlet?gettile&map=OSM&zoomlevel=11&x=1073&y=703" -->
                  <v-img
                    :src="layer.meta.image"
                    class="grey lighten-2"
                    cover
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-row>
                    </template>
                    <div class="overlay-darken">
                      <p class="text-left text-bottom text-white unselectable">
                        {{ layer.meta.name }}
                      </p>
                    </div>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div
          class="overlays"
          style="width:50%;!important"
        >
          <h3 class="unselectable">
            {{ $t('layerView.vectorLayer') }}
          </h3>
          <div id="overlay-option">
            <v-text-field
              v-if="items.length > 10"
              v-model="search"
              class="search-bar"
              :label="$t('layerView.searchVectorLayer')"
              outlined
              clearable
              clear-icon="mdi-close-circle-outline"
            />
            <v-treeview
              v-model="selection"
              selectable
              :selected-color="baseColorAccent"
              open-on-click
              transition
              hoverable
              :items="items"
              :search="search"
              @input="onOverlayUpdate"
            >
              <template v-slot:append="{item}">
                <v-icon
                  v-if="item.selectable"
                >
                  mdi-cursor-pointer
                </v-icon>
              </template>
            </v-treeview>
          </div>
        </div>
        <mq-layout
          mq="desktop"
        >
          <v-btn
            class="button-close-layer"
            fab
            absolute
            top
            right
            color="white"
            @click.native="$store.commit('closeLayerMenu')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </mq-layout>
      </v-card>
    </mq-layout>
  </div>
</template>

<script>

import ViewBox from '../ViewBox.vue';
import { Mapable } from '../../mixins/Mapable';
import { EventBus } from '../../event-bus';

export default {
  name: 'LayerView',
  components: {
    ViewBox,
  },
  mixins: [Mapable],
  props: {},
  data() {
    return {
      displayed: false,
      toggle_exclusive: undefined,
      layerItems: [],
      layerItemsMeta: [],
      defaultLayer: undefined,
      items: [],
      selection: [],
      search: null,
      baseColorAccent: this.$appConfig.baseColorAccent,
      layerOverlays: [],
      mapBound: false,
    };
  },
  computed: {
    currentView() {
      return this.map.getView();
    },
  },
  mounted() {
    const me = this;
    /* FEATURE get preview images according to map center
     * https://gis.stackexchange.com/questions/133205/wmts-convert-geolocation-lat-long-to-tile-index-at-a-given-zoom-level
     * console.log(this.map.getView().getCenter());
     */
    if (me.$route.query.layers !== undefined) {
      this.selection = me.$route.query.layers.split(',');
      // TODO override showAtStart layers
      // TODO also get base maps
      // wait until all layers are added to map, then set layer to visible
      EventBus.$on('mapbox-map-mounted', () => {
        this.onOverlayUpdate(this.selection);
      });
    }
    EventBus.$on('toggleLayer', (layer, onoff) => {
      if (!onoff) {
        this.onOverlayUpdate(this.selection.push(layer));
      } else {
        this.selection = this.selection.filter((e) => e !== layer);
        this.onOverlayUpdate(this.selection);
      }
    });
    EventBus.$on('layer-meta', (layer) => {
      // TODO: Set start layer as active
      if (layer.meta.type === 'base') {
        if (layer.meta.isDefaultBaseLayer === true) {
          this.defaultLayer = layer;
          this.$nextTick(() => {
            this.layerItems.forEach((baseLayer) => {
              if (baseLayer.meta.isDefaultBaseLayer === true) {
                if (me.$mq === 'desktop') {
                  this.showLayerAsActive(baseLayer.meta.lid, true);
                }
              }
            });
          });
        }
        this.layerItems.push(layer);
      }
      if (layer.meta.type === 'overlay') {
        this.layerOverlays.push(layer);
        if (layer.meta.showAtStart === true) {
          me.selection.push(layer.meta.lid);
        }
      }
    });
    me.onOverlayUpdate(me.selection);
    me.items = this.$appConfig.overlays;
  },
  created() {
  },
  // define methods under the `methods` object
  methods: {
    onMapBound() {
      this.mapBound = true;
      // const me = this;
      // me.createLayerItems();
      // me.createOverlayItems();
    },
    onOverlayUpdate(selection) {
      if (Array.isArray(selection) === false) return;
      const me = this;
      const query = {
        lat: me.$route.query.lat,
        lon: me.$route.query.lon,
        z: me.$route.query.z,
        ...((selection.length > 0) && { layers: [selection] }),
      };
      me.$router.replace({
        query,
      }).catch(() => {
        /**
         *  To avoid a error caused by "NavigationDuplicated"
         *  we just catch the error and do nothing
        */
      });
      me.layerOverlays.forEach((overlay) => {
        if (selection.includes(overlay.meta.lid)) {
          overlay.layers.forEach((mapboxLayer) => {
            me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'visible');
          });
          if (overlay.meta.attributionText !== undefined && overlay.meta.attributionHTML !== undefined) {
            me.$store.commit('addToHtmlAttributionList', `${overlay.meta.name}: ${overlay.meta.attributionHTML}`);
            me.$store.commit('addToTextAttributionList', `${overlay.meta.name}: ${overlay.meta.attributionText}`);
          }
        } else {
          overlay.layers.forEach((mapboxLayer) => {
            me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'none');
          });
          if (overlay.meta.attributionText !== undefined && overlay.meta.attributionHTML !== undefined) {
            me.$store.commit('removeFromHtmlAttributionList', `${overlay.meta.name}: ${overlay.meta.attributionHTML}`);
            me.$store.commit('removeFromTextAttributionList', `${overlay.meta.name}: ${overlay.meta.attributionText}`);
          }
        }
      });
      if (typeof me.map !== 'undefined') {
        this.map.panTo(me.map.getCenter());
      }
    },
    setLayerVisible(lid) {
      const me = this;
      me.layerItems.forEach((layer) => {
        if (layer.meta.lid === lid) {
          layer.layers.forEach((mapboxLayer) => {
            me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'visible');
            if (layer.meta.attributionText !== undefined && layer.meta.attributionHTML !== undefined) {
              me.$store.commit('addToHtmlAttributionList', `${layer.meta.name}: ${layer.meta.attributionHTML}`);
              me.$store.commit('addToTextAttributionList', `${layer.meta.name}: ${layer.meta.attributionText}`);
            }
          });
          if (me.$mq === 'desktop') {
            this.showLayerAsActive(layer.meta.lid, true);
          }
        } else {
          layer.layers.forEach((mapboxLayer) => {
            me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'none');
            if (layer.meta.attributionText !== undefined && layer.meta.attributionHTML !== undefined) {
              me.$store.commit('removeFromHtmlAttributionList', `${layer.name}: ${layer.meta.attributionHTML}`);
              me.$store.commit('removeFromTextAttributionList', `${layer.name}: ${layer.meta.attributionText}`);
            }
          });
          if (me.$mq === 'desktop') {
            this.showLayerAsActive(layer.meta.lid, false);
          }
        }
      });
    },
    showLayerAsActive(lid, bool) {
      if (bool) {
        document.getElementById(lid).classList.add('layer-active');
        document.getElementById(lid).style.borderColor = this.baseColorAccent;
      } else {
        document.getElementById(lid).classList.remove('layer-active');
        document.getElementById(lid).style.borderColor = '';
      }
    },
    long2tile(lon, zoom) {
      return (Math.floor(((lon + 180) / 360) * 2 ** zoom));
    },
    lat2tile(lat, zoom) {
      // eslint-disable-next-line max-len
      return (Math.floor(((1 - Math.log(Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)) / Math.PI) / 2) * 2 ** zoom));
    },
  },
};

</script>

<style scoped>

  .comboBox {
    padding: 0;
    margin: 0;
    height: 5%;
  }

  .base-container {
    padding: 0;
    margin: 0;
    text-align: center;
    vertical-align: middle;
  }
  .text-center {
    vertical-align: middle;
  }
  .unselectable {
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }

  .item-text {
    font-size: 1.5em;
    line-height: 3.5rem;
  }

  .text-bottom {
    vertical-align: bottom;
    margin: 0;
  }

  .text-white {
    color: #ffffff;
  }
  .overlay-darken {
    width: 100%;
    word-wrap: break-word;
    background: rgba(50,50,50,0.55);
    position: absolute;
    bottom: 0;
    text-align: left;
    padding-left: 0.5rem;
  }

  h3 {
    font-weight: 500;
    padding-left: 0.75em;
    margin-bottom: 0.5em;
    height: 2em;
    width: 100%;
  }

  /* base layer cards (desktop) */
  .base-layer-card {
    border-radius: 10px !important;
    position: relative;
    margin: 2px;
  }
  .layer-active {
    border: 2px solid;
    margin: 0;
  }

  .overlays {
    overflow-y: auto;
  }
  .mobileLayerCard{
    min-height:100%;
    padding-bottom: 30%;
  }
  .desktopLayerCard{
    /* max-height:75%; */
    max-height:50%;
    display:flex;
    flex-direction: row;
    visibility:visible;
    max-width:50vw;
    position: fixed;
    left: 1em;
    bottom: 1em;
    padding: 0.5em;
    margin:0;
    border-radius:7px;
  }
  .search-bar {
    width: 90%;
    margin: 0 5%;
  }
</style>
